module.exports = {
  'zone:nc': 'North Central',
  'zone:nw': 'North West',
  'zone:ne': 'North East',
  'zone:ss': 'South South',
  'zone:se': 'South East',
  'zone:sw': 'South West'
}
